import { reactive, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useLoader } from '../useLoader'
import { useError } from '../useError'
import { usePoliticalActions } from './usePoliticalActions'
import { useRequestForm } from './useRequestForm'
import { useNotifications } from '@/services/notification/useNotifications'
import { useDialog } from '@/services/useDialog'
import { useLogs } from '@/services/useLogs'
import { useTopData } from '@/services/useHome'
import axios from '@/axios'

const rejectHeaders = reactive([
  { title: '報告日', attr: 'submissionDate', comment: '' },
  { title: '政務活動項目', attr: 'actionTypes', comment: '' },
  { title: '開始 〜 終了日', attr: 'period', comment: '' },
  { title: '参加者氏名', attr: 'memberName', comment: '' },
  { title: '場所', attr: 'place', comment: '' },
  { title: '目的', attr: 'purpose', comment: '' },
  { title: '宿泊場所', attr: 'remarks', comment: '' },
  { title: 'メッセージ', attr: 'officeMessage', comment: '' },
])

const isRejectBtnEnabled = ref(false)
const rejectedAttrs = reactive([])

export const useRequestReject = () => {
  const { toggleShowLoader } = useLoader()
  const { toggleShowError } = useError()
  const route = useRoute()
  const resetRequestRejectedItems = () => {
    while (rejectedAttrs.length > 0) {
      rejectedAttrs.pop()
    }
    rejectHeaders.forEach(x => (x.comment = ''))
  }

  let data = reactive({})

  const toUnderscoreCase = str => {
    return str
      .split(/(?=[A-Z])/)
      .join('_')
      .toLowerCase()
  }

  const toSnake = () => {
    for (let i = 0; i < rejectedAttrs.length; i++) {
      Object.keys(rejectedAttrs[i]).forEach(function(key) {
        if (key === 'target') {
          rejectedAttrs[i][key] = toUnderscoreCase(rejectedAttrs[i][key])
        }
      })
    }
  }
  const submitReject = async (id, documentId, type, userRank) => {
    const {
      getActivitiesAfterResponse,
      currentPoliticalAction,
    } = usePoliticalActions()
    const { getNotificationsAfterResponse } = useNotifications()
    const { getTimelineAfterResponse } = useLogs()
    const { getTopDataAfterResponse } = useTopData()
    const { getBitActionType } = useRequestForm()
    try {
      toggleShowLoader(true)
      // 会派事務局の時にアップデートを行う
      if (userRank === 2) {
        const payload = {
          is_temporary: false,
          document_type: currentPoliticalAction.application.documentType,
          action_types: getBitActionType(
            currentPoliticalAction.selectedActionTypes,
          ),
          start_date: currentPoliticalAction.startDate,
          end_date: currentPoliticalAction.endDate,
          place: currentPoliticalAction.place,
          member_name: currentPoliticalAction.memberName,
          purpose: currentPoliticalAction.purpose,
          remarks: currentPoliticalAction.application.remarks,
          submission_date: currentPoliticalAction.submissionDate,
          images: currentPoliticalAction.application.images,
        }
        await axios.put(`/actions/${id}`, payload)
      }

      toSnake()
      data = {
        document_id: documentId,
        document_type: type,
        sent_back_items: rejectedAttrs,
      }
      let res = null
      res = await axios.post(`/actions/reject`, data)
      if (route.name === 'Activities') {
        await getActivitiesAfterResponse(res)
      } else if (route.name !== 'Activities') {
        const { closeDialog } = useDialog()
        closeDialog()
        if (route.name === 'Top') {
          await getTopDataAfterResponse(res)
        } else if (route.name === 'Logs') {
          await getTimelineAfterResponse(res)
        } else if (route.name === 'Notifications') {
          await getNotificationsAfterResponse(res)
        }
      }
      toggleShowLoader(false)
    } catch (e) {
      console.log('err', e, e.resuponse)
      toggleShowError(true)
      toggleShowLoader(false)
    }
  }

  return {
    rejectHeaders,
    rejectedAttrs,
    isRejectBtnEnabled,
    resetRequestRejectedItems,
    submitReject,
    toSnake,
  }
}
